import Errors from './../../../js/base/Errors';
import Options from './options';

class Data {
  constructor() {
    this.data = {
      errors: new Errors(),
      options: new Options(),
      optionsUpload: {},
      typePopUp: 'Images',
      previewFile: {
          show: false,
          type: 'image',
          file: {},
      },
      canMoveFiles: false,
      activeDirectory: 'all',
      tabsFolders: [],
      headers: {
          authorization: 'Bearer ' + localStorage.getItem('token')
      },
      filters: {
          search: '',
          order: 'date', // date, asc, desc
          typeView: 'th' // th th-large th-list
      },
      tabActive: {
          directories: {},
          directoryActive: 'all',
          search: '',
          order: 'date', // date, asc, desc
          typeView: 'th' // th th-large th-list
      },
      defaultValues: {
          type: 'Images',
          module: ['Images', 'Icons', 'Buttons', 'Gifs']
      },
      byMove: false,
      directory: {
          id_directory: '',
          id_uploader_module: '', // 1 -	Images , 2 -	Videos,  3 - Files
          type_module: 'Images', // 1 -	Images , 2 -	Videos,  3 - Files
          name: '',
      },
      file: {
          name: '',
      },
      modalShow: '',
      modal: {
          delete: {
              show: false,
              config: {},
          }
      },
      modals: {
          type: '',
          item: '',
          status: false,
      },
      active: 'user',
      choose: 1, // 1 - arquivo só 2 - dois ou mais
      filesSelected: [],
      filesSelectedGroup: { first: false, last: false},
      filesSelectedList: [],
      directorySelected: '',
      directoryisEditing: '',
      filesFilter: {},
      data: {
          name: '', // module
          modules: ['User', 'Images', 'Icons', 'Gifs', 'Buttons'], // module
          directories: {}, files: {},

          teste: {},
          user: {
              images: {
                  type: 'user', editable: true, title: 'user-files', directories: {}, files: {}
              },
              directories: {},
          },

          images: {
              images: {
                  type: 'images', editable: false, title: 'images-files', directories: {}, files: {}
              }
          },

          icons: {
              images: {
                  type: 'icons', editable: false, title: 'icons-files', directories: {}, files: {}
              }
          }
      },
      accept: {
          Images: '.png, .jpg, .jpeg, .gif',
          Files: '.png,.jpg,.jpeg,.gif,.pdf,.doc,.xsl,.ppt,.txt,.zip',
          Videos: 'video/mp4',
          mazSize: '',
      },
      filtesFormatVuex: {
          Files: {},
          Images: {},
          Videos: {},
      },
      editorToastUI: {
        data: {
          name : ''
        }
      },
      filesPreview: [],
      uploadPercentage: 0
    };
  }

  getData() {
    return this.data;
  }
};

export default Data;



// WEBPACK FOOTER //
// ./src/components/general/FilesManager/data.js